/**
 * @description
 *
 * @sort creation_date,
 * @sort dispatch_date,
 * @sort reception_date,
 * @sort created_at,
 * @sort updated_at
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'solicitante',
        value: 'g_to_supervisor_full_name',
        sortable: 'g_to_supervisor_id',
    },
    {
        text: 'destino',
        value: 'wh_to_warehouse_name',
        sortable: 'wh_to_warehouse_id',
    },
    {
        text: 'responsable',
        value: 'g_from_supervisor_full_name',
        sortable: 'g_from_supervisor_id',
    },
    {
        text: 'origen',
        value: 'wh_from_warehouse_name',
        sortable: 'wh_from_warehouse_id',
    },
    {
        text: 'estado',
        value: 'g_state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    creada: 'accent lighten-3',
                    despachada: 'secondary lighten-3',
                    recepción_parcial: 'info lighten-3',
                    recepcionada: 'success lighten-3',
                    cerrada: 'grey darken-4 white--text',
                },
                noEvents: true,
                small: true,
            },
        },
        sortable: 'g_state_id',
    },
    {
        text: 'despacho',
        value: 'dispatch_date',
        sortable: 'dispatch_date',
        align: 'right',
        format: 'datetime',
    },
    {
        text: 'recepción',
        value: 'reception_date',
        align: 'right',
        sortable: 'reception_date',
        format: 'datetime',
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        sortable: true,
        format: 'datetime',
    },
]
